import { inject } from '@angular/core';
import { UserModeService } from './user-mode';
import type { UserMode } from './user-mode';
import { Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { first, map } from 'rxjs';

export const userModeGuard = (expectedModes: UserMode[]) => () => {
  const userModeService = inject(UserModeService);
  const router = inject(Router);
  const userMode = userModeService.userMode;
  return toObservable(userMode).pipe(
    first((mode) => !!mode),
    map((mode) => {
      if (!expectedModes.includes(mode)) {
        return router.createUrlTree(['/error/404']);
      }
      return true;
    }),
  );
};
